/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { FormControl, FormHelperText, Select, MenuItem, InputLabel } from '@material-ui/core'

import Actions from '../../../../fluid/Actions/ActionFactory'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      // primary: {
      //     main: "#FF6600",
      //     contrastText: "#FFFFFFFF"
      // },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => {

}

class FlexBotPicker extends Component {
    state = {
        bots : null,
        receiving_bots : false,
        bots_err : false
    }

    handleChange = (event) => {
        this.props.update_value(this.props.instance.id, "text", event.target.value.toString())
    }

    getBots = () => {
        this.setState({
            ...this.state,
            receiving_bots : true
        }, () => {
            Actions('http_request', {
                url : "/sainapse/bot/",
                method : "get",
                data : {}
            }).then(res => {
                this.setState({
                    ...this.state,
                    bots : res.data.result,
                    receiving_bots : false,
                    bots_err : false
                })
            }).catch(err => {
                this.setState({
                    ...this.state,
                    bots : null,
                    receiving_bots : false,
                    bots_err : true
                })
            })
        })
    }
    
    renderOptions = () => {
        if (this.state.bots_err) {
            return (
                <MenuItem value = "" disabled><em>Error Retreiving Scripts</em></MenuItem>
            )
        } else {
            if (this.state.receiving_bots) {
                return (
                    <MenuItem value = "" disabled><em>Retreiving Scripts...</em></MenuItem>
                )
            } else {
                if (this.state.bots !== null) {
                    let bots = this.state.bots.map(bot => {
                        return (
                            <MenuItem value = {bot.id}>{bot.name}</MenuItem>
                        )
                    })
    
                    return bots
                }
            }
        }
    }

    getParam = (param_name, value_type) => {
        let parameter = null

        this.props.instance.component_params.map(param => {
            if (param.name === param_name) {
                parameter = param.value[value_type]
            }
        })

        return parameter
    }

    render() {
        return (
            <FormControl
                style = {{width : '100%'}}
                variant = 'standard' 
                margin = 'dense'
                error = {this.state.error}
                disabled = {this.props.disabled}
            >
                <InputLabel>{this.props.instance.name}</InputLabel>
                <Select
                    value = {this.props.instance.value.text}
                    onChange = {(event) => this.handleChange(event)}
                    onOpen = {this.getBots}
                    onBlur = {this.validateAndPush}
                >
                    {this.renderOptions()}
                </Select>
                <FormHelperText>{this.getParam("helper_text", "text")}</FormHelperText>
            </FormControl>
        );
    }
}

export default withStyles(styles)(FlexBotPicker);